var RNGA = require('react-native-gesture-handler');

exports._tapGestureHandler = RNGA.TapGestureHandler;
